<script>
import { mapActions, mapState } from "vuex";
import DocumentPath from "@/components/_Shared/Documents/DocumentPath";
import DocumentContent from "@/components/_Shared/Documents/DocumentContent";
import Create from "@/components/_Shared/Documents/NewDocument/Index";
import IconTooltip from "@/components/_Shared/Users/Status/IconTooltip";

import documentMixin from "@/mixins/documentMixin";

export default {
  mixins: [documentMixin],
  components: {
    DocumentPath,
    DocumentContent,
    Create,
    IconTooltip
  },
  data() {
    return {
      id: null,
      newDocumentVisible: false
    };
  },
  props: {
    professional: {
      type: Object,
      require: true
    }
  },
  computed: {
    ...mapState("documents", ["documents"]),

    isSelfie: item => {
      return item === "SELFIE";
    }
  },
  methods: {
    ...mapActions("documents", [
      "listAllDocuments",
      "createDocument",
      "updateDocument",
      "approveDocument",
      "setDocumentReadyToProcess",
      "setDocumentPendingApproval"
    ]),

    isResponseOk(responseCode) {
      return responseCode === 200;
    },

    async refreshCurrentContext() {
      await this.listAllDocuments(this.professional.account.id);
      this.$emit("refresh");
    },

    documentTypeDisplayName(documentType) {
      return this.getDocumentTypeStatuses(documentType);
    },
    async updateByDocumentType(documentType) {
      let response = await this.updateDocument(documentType);

      let status = this.isResponseOk(response.status)
        ? `${this.documentTypeDisplayName(documentType)} atualizado com sucesso`
        : `Não foi possivel atualizar ${documentTypeDisplayName}`;

      this.$toast(`${status}`);
    },

    async approveByDocumentType(documentType) {
      let response = await this.approveDocument(documentType);

      let status = this.isResponseOk(response.status)
        ? `${this.documentTypeDisplayName(documentType)} aprovado com sucesso`
        : `Não foi possivel aprovar o documento ${documentTypeDisplayName}`;

      this.$toast(`${status}`);
    },

    async setDocumentPendingApprovalDocumentType(documentType) {
      let response = await this.setDocumentPendingApproval(documentType);

      let status = this.isResponseOk(response.status)
        ? `${this.documentTypeDisplayName(documentType)} enviado com sucesso`
        : `Não foi possivel enviar o documento ${documentTypeDisplayName}`;

      this.$toast(`${status}`);
    },

    async setDocumentReadyToProcessByDocumentType(documentType) {
      let response = await this.setDocumentReadyToProcess(documentType);

      let status = this.isResponseOk(response.status)
        ? `${this.documentTypeDisplayName(documentType)} enviado com sucesso`
        : `Não foi possivel enviar o documento ${documentTypeDisplayName}`;

      this.$toast(`${status}`);
    },

    formatExternalId(externalId = null) {
      return externalId === "" || externalId === null
        ? "Ainda não registrado"
        : externalId;
    },

    async listAllProfessionalDocuments() {
      await this.listAllDocuments(this.professional.account.id);
    }
  },
  async mounted() {
    await this.listAllProfessionalDocuments();
  }
};
</script>

<template>
  <div>
    <div class="create-btn">
      <v-btn
        small
        outlined
        rounded
        class="ml-3"
        color="secondary"
        @click="newDocumentVisible = true"
        >Criar documento</v-btn
      >

      <v-spacer></v-spacer>
    </div>

    <template v-for="document_type in Object.keys(documents)">
      <div
        class="style"
        :key="documents[document_type]['id']"
        v-if="isOcrDocument(documents[document_type]['document_type'])"
      >
        <div class="title_header">
          {{
            documents[document_type]["document_type"]
              | getDocumentTypeStatuses()
          }}
        </div>

        <div>
          <div class="property">
            STATUS:
            <span
              :style="getStatus(documents[document_type]['status'], 'color')"
            >
              <icon-tooltip
                :options="getStatus(documents[document_type]['status'])"
              />
              {{
                documents[document_type]["status"] | getStatuses("name")
              }}</span
            >
          </div>
          <div
            class="property"
            v-if="
              documents[document_type]['status'] === 'approved' ||
                documents[document_type]['status'] === 'reproved'
            "
          >
            SITUAÇÃO:
            <v-chip
              small
              outlined
              :style="isApproved(documents[document_type]['approved'])"
              >{{
                isApproved(documents[document_type]["approved"]).name
              }}</v-chip
            >
          </div>
          <div>
            COMBATE A FRAUDE ID:
            <v-chip small>{{
              formatExternalId(documents[document_type]["external_id"])
            }}</v-chip>
          </div>
        </div>

        <document-path
          class="paths"
          v-if="isOcrDocument(documents[document_type]['document_type'])"
          :paths="documents[document_type]['paths']"
          :documentType="document_type"
        />

        <document-content
          :document="documents[document_type]"
          v-if="isOcrDocumentContent(documents[document_type]['document_type'])"
        />

        <div class="management-btn">
          <v-btn
            class="btn"
            color="primary"
            small
            :loading="documents[document_type]['documentSavingLoader']"
            :disabled="documents[document_type]['documentApprovingLoader']"
            @click="
              updateByDocumentType(document_type), refreshCurrentContext()
            "
          >
            <span>salvar</span>
          </v-btn>
          <v-btn
            class="btn"
            v-if="isDocumentHandled(documents[document_type]['status'])"
            color="yellow"
            :loading="documents[document_type]['documentApprovingLoader']"
            :disabled="documents[document_type]['documentSavingLoader']"
            small
            @click="approveDocument(document_type), refreshCurrentCotext()"
          >
            <span>Aprovar Documento</span>
          </v-btn>
          <v-btn
            class="btn"
            v-if="isDocumentProcessing(documents[document_type]['status'])"
            color="accent"
            :loading="documents[document_type]['documentApprovingLoader']"
            :disabled="documents[document_type]['documentSavingLoader']"
            small
            @click="setDocumentPendingApprovalDocumentType(document_type)"
          >
            <span>Solicitar aprovação manual</span>
          </v-btn>
          <v-btn
            v-if="isDocumentReadyToProcess(documents[document_type]['status'])"
            color="accent"
            :loading="documents[document_type]['documentApprovingLoader']"
            :disabled="documents[document_type]['documentSavingLoader']"
            small
            @click="
              setDocumentReadyToProcessByDocumentType(document_type),
                refreshCurrentContext()
            "
          >
            <span>Documento pronto para analise</span>
          </v-btn>
        </div>
      </div>
    </template>
    <create
      :visible="newDocumentVisible"
      :professional="professional"
      @close="newDocumentVisible = false"
      @refresh="listAllProfessionalDocuments()"
    />
  </div>
</template>

<style scoped>
.style {
  padding: 20px;
  margin: 20px;
  align-content: space-between;
  border-bottom: solid 2px #eee;
}

.title_header {
  font-size: 30px;
  text-align: center;
  margin-top: 20px;
}

.property {
  padding-bottom: 20px;
}

.paths {
  margin: 50px;
}

.create-btn {
  margin: 20px;
  text-align: right;
}

.management-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Documents.vue